import { IGetState, TBoardId } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { boardActiveRequestsUpdate } from '../../../store/requestsState/effects/boardActiveRequestsUpdate';
import { deleteRest } from './api/deleteRest';
import { IWebhook } from '../../../types/rest/IRestUserBoardMeta';
import { getBoardUserMeta } from 'app/store/model/boardUserMetas/selectors/getBoardUserMeta';
import { boardUserMetasActionSetAction } from 'app/store/model/actions/boardUserMetasActionSetAction';
import { boardUserMetasActionSet } from 'app/store/model/boardUserMetas/actions/boardUserMetaActionSet';
import { updateAction } from 'app/store/model/boardUserMeta/actions/updateAction';

export const webhooksDelete = (
    boardId: TBoardId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(boardActiveRequestsUpdate(boardId, 1));
        return dispatch(deleteRest(boardId))
            .then(() => {
                const userMeta = {
                    ...getBoardUserMeta(getState(), boardId),
                    webhooks: null as IWebhook,
                };
                dispatch(boardUserMetasActionSetAction(boardUserMetasActionSet(boardId, updateAction(userMeta))));
            })
            .finally(() => {
                dispatch(boardActiveRequestsUpdate(boardId, -1));
            });
    };
    return action;
}
